export function isValidStudentRedirectPath(
  path: string | null | undefined
): boolean {
  if (!path) return false;

  const pathParts = path.replace(/^\/+|\/+$/g, '').split('/');

  // check if first part is a 2-character region code
  if (pathParts[0]?.length === 2) {
    // remove the region prefix
    pathParts.shift();
  }

  if (pathParts.length === 0) {
    return false;
  }

  // check if the first part is either 'student', 'class', or an interactive path (for Ebook mentor text that require signin)
  return pathParts[0].startsWith('student') || pathParts[0] === 'class';
}
